import type { LocalizedString } from 'typesafe-i18n';
import { z } from 'zod';

import { ONLY_DIGITS_REGEX } from '../../const/zod/zod';

export const ADVISOR_ID_MIN_LENGTH = 3;
export const ADVISOR_ID_MAX_LENGTH = 6;

export type GetAdvisorIdSchemaErrorMessages = {
	getAdvisorIdLengthError: (arg: {
		maxLength: number;
		minLength: number;
	}) => LocalizedString;
};

export const getAdvisorIdSchema = (
	errorMessages?: GetAdvisorIdSchemaErrorMessages,
) => {
	const advisorIdLengthError = errorMessages?.getAdvisorIdLengthError({
		maxLength: ADVISOR_ID_MAX_LENGTH,
		minLength: ADVISOR_ID_MIN_LENGTH,
	});
	const schema = z.object({
		advisorId: z
			.string()
			.min(ADVISOR_ID_MIN_LENGTH, advisorIdLengthError)
			.max(ADVISOR_ID_MAX_LENGTH, advisorIdLengthError)
			.refine((val) => !val || ONLY_DIGITS_REGEX.test(val), {
				message: advisorIdLengthError,
			}),
	});

	return schema;
};
